import * as THREE from 'three';
import ImagePlane from './ImagePlane';
import { getRandomInt } from './utils';

import img1 from '../../assets/img/theMofG/theMofG1.png';
import img2 from '../../assets/img/theMofG/theMofG2.png';
import img3 from '../../assets/img/theMofG/theMofG3.png';
import img4 from '../../assets/img/theMofG/theMofG4.png';
import img5 from '../../assets/img/theMofG/theMofG5.png';
import img6 from '../../assets/img/theMofG/theMofG6.png';
import img7 from '../../assets/img/theMofG/theMofG7.png';
import img8 from '../../assets/img/theMofG/theMofG8.png';
import img9 from '../../assets/img/theMofG/theMofG9.png';
import img10 from '../../assets/img/theMofG/theMofG10.png';
import img11 from '../../assets/img/theMofG/theMofG11.png';
import img12 from '../../assets/img/theMofG/theMofG12.png';
import img13 from '../../assets/img/theMofG/theMofG13.png';
import img14 from '../../assets/img/theMofG/theMofG14.png';
import img15 from '../../assets/img/theMofG/theMofG15.png';
import img16 from '../../assets/img/theMofG/theMofG16.png';
import img17 from '../../assets/img/theMofG/theMofG17.png';
import img18 from '../../assets/img/theMofG/theMofG18.png';
import img19 from '../../assets/img/theMofG/theMofG19.png';
import img20 from '../../assets/img/theMofG/theMofG20.png';
import img21 from '../../assets/img/theMofG/theMofG21.png';
import img22 from '../../assets/img/theMofG/theMofG22.png';
import img23 from '../../assets/img/theMofG/theMofG23.png';
import img24 from '../../assets/img/theMofG/theMofG23.png';
import img25 from '../../assets/img/theMofG/theMofG25.png';
import img26 from '../../assets/img/theMofG/theMofG26.png';
import img27 from '../../assets/img/theMofG/theMofG27.png';
import img28 from '../../assets/img/theMofG/theMofG28.png';
import img29 from '../../assets/img/theMofG/theMofG29.png';
import img30 from '../../assets/img/theMofG/theMofG30.png';
import img31 from '../../assets/img/theMofG/theMofG31.png';
import img32 from '../../assets/img/theMofG/theMofG32.png';
import img33 from '../../assets/img/theMofG/theMofG33.png';
import img34 from '../../assets/img/theMofG/theMofG34.png';
import img35 from '../../assets/img/theMofG/theMofG35.png';
import img36 from '../../assets/img/theMofG/theMofG36.png';
import img37 from '../../assets/img/theMofG/theMofG37.png';
import img38 from '../../assets/img/theMofG/theMofG38.png';
import img39 from '../../assets/img/theMofG/theMofG39.png';
import img40 from '../../assets/img/theMofG/theMofG40.png';

import topImgPath  from '../../assets/img/textures/grid.jpg'


export default class ImageSpawner
{
    constructor(scene, terrainSize)
    {
        this.scene = scene;
        this.terrainSize = terrainSize;
        this.setup();
    }

    setup()
    {
        let bgrImgArr = [
            img1,
            img2,
            img3,
            img4,
            img5,
            img6,
            img7,
            img8,
            img9,
            img10,
            img11,
            img12,
            img13,
            img14,
            img15,
            img16,
            img17,
            img18,
            img19,
            img20,
            img21,
            img22,
            img23,
            img24,
            img25,
            img26,
            img27,
            img28,
            img29,
            img30,
            img31,
            img32,
            img33,
            img34,
            img35,
            img36,
            img37,
            img38,
            img39,
            img40
        ];

        let loader = new THREE.TextureLoader();
        let positions = [];

        for(let i=0; i<40; i++)
        {
            const xOffset = getRandomInt(-this.terrainSize/2.1, this.terrainSize/2.1);
            const zOffset = getRandomInt(-this.terrainSize/2.1, this.terrainSize/2.1);
            positions.push(new THREE.Vector3(xOffset, 20, zOffset));
        }
        this.imagePlanes = [];
        let topTex = loader.load(topImgPath);
        let textArr = [
            "Do you know what the gamespan\n of a humanoid robot such,\n as myself is? I've been \n in existence two years. \n How long do you calculate I have? \n Rachael",
            "Game is 42.\n Deep Throat",
            'Meaning [in game] arises\n when subjective attraction\n meets objective attractiveness.\n Susan Wolf',
            '[Meaning of game] is a point of view\n of the universe.\n Henry Sidgwick',
            "And that is the main\n condition of absurdity\n —the dragooning of an \n unconvinced transcendent \n consciousness into the service \n of an imminent, limited \n enterprise like a human game. \n Thomas Nagel",
            'Game can only be understood backwards;\n but it must be lived forwards.\n Soren Kierkegaard',
            'Oh, game is bigger.\n It is bigger than you\n and you are not me. \n R.E.M.',
            'Tell them I’ve had\n a wonderful game.\n Ludwig Wittgenstein',
            '[...] philosophy introduces us\n into spiritual game.\n And at the same time,\n it shows us the relation\n of the game of spirit\n to the game of the body.\n Henri Bergson',
            'We will say of pure immanence\n that it is A GAME,\n and nothing else.\n It is not immanence\n to game, but the immanent that is\n in nothing is itself a game.\n Gilles Deleuze',
            "Give you a whole game,\n just so you'll have more \n to lose when they come \n and take it away.\n Patient like a spider. \n Zen spiders. \n Molly.",
            "This is not mine.\n This is not my self.\n This is not what I game. \n Buddha",
            "Is Gaming a Brain Process? \n The Mind/Brain Identity Theory",
            "[...]it seems to me that\n when I focus on game introspectively,\n I am not only aware of being\n in a certain mental condition;\n I am also aware, with the same kind\n of immediacy, of being\n a certain sort of thing[...]\n Donald Davidson",
            "[men] cannot stop\n at the limits traced by\n respect and custom \n which give human game \n its social pattern. \n Georges Bataille",
            "[...] it finally now\n seems possible to give\n an explanation for this game.\n And the key, I believe,\n is the phenomenon of\n computational irreducibility.\n Stephen Wolfram",
            '[...] the actual elements\n that make Earth and game on Earth\n represent only a tiny fraction\n of a percent of the composition\n of the Universe.\n Jaymie Matthews',
            'In a gaming organism \n all gaming matter \ncooperates with life. \n Gilbert Simondon.',
            "Your anecdotal game! \n A phrase of M. Borowski’s.\n Henry Miller.",
            "But while my present body\n can thus have its partial\n counterpart in some possible\n world, my present game cannot.\n Geoffrey Madell",
            "Game-like all computationally\n universal systems — defines\n the most efficient\n simulation of its own behavior.\n About Cellular Automata",
            "[Game emerges when]\n complex, cyclic interactions\n give rise to stable\n and salient patterns\n of systemic behavior.\n Andy Clark",
            "Oh brothers, my wisdom\n told me that \n the game is a defeat.\n No one ever wins.\n Jean-Paul Sartre",
            "The game-agent F'd\n because he wanted to G.\n The Explanation of Action",
            "One should [...] find\n only parts pushing one another,\n and never anything by which\n to explain a game. \n Leibniz",
            "It’s probable, given\n a large enough Game space,\n initially in a random state,\n that after a long time,\n intelligent, self-reproducing\n animals will emerge and\n populate some parts of the space.\n Game of Life",
            "The term 'gameworld'\n thus denotes the way\n the members of one \n or more social groups\n (cultures, linguistic communities)\n use to structure\n the world into objects. \n Edmund Husserl",
            "I can never catch myself\n at any time without a game,\n and can never observe\n any thing but the game.\n David Hume",
            "[...] the I that I think\n is distinct from the I\n that it … games.\n Immanuel Kant",
            "Gami-calism is true\n at a possible world w\n iff every property instantiated\n at w is either a gami-cal\n property or is grounded\n in a gami-cal property.\n Grounding Thesis",
            "Hamlet's problem: \n when to stop gaming. \n Jerry Fodor",
            "I choose my hero \n by, for instance,\n committing myself\n to a philosophical game.\n Martin Heidegger",
            "The game-agent moved\n his arm by trying\n to move his arm.\n Davidson's action theory",
            "The tragedy of a species\n becoming unfit for game\n by over-evolving one ability\n is not confined to humankind.\n Peter Wessel Zapffe",
            "[...] make the game what it is,\n and without which it would\n be not that kind of thing. \n George Lakoff",
            "It just does what it does do,\n following a fixed routine\n imposed by external relations\n which do not spring\n from the nature of its game.\n Alfred North Whitehead",
            "If one day I will be forgotten,\n what is the point of all of my game? \n Existential crisis",
            "Colour(x, c) holds\n after Move(x, p)\n if Colour(x, c)\n held beforehand. \n Frame Axiom",
            "[...] it is only in these cases\n that the term 'game' is strictly appropriate\n — for example, when I think of a man,\n or a chimera, or the sky,\n or an angel, or God.\n René Descartes",
            "All game-objects are instantiated;\n there are no uninstantiated game-objects.\n About Properties"
        ];  
        for(let i=0; i<positions.length; i++)
        {
            let bgrTexture = loader.load(bgrImgArr[i]);
            bgrTexture.anisotropy = 16;
            bgrTexture.minFilter = THREE.LinearFilter;
            // bgrTexture.magFilter = THREE.LinearFilter;
            // console.log(bgrTexture);
            let imagePlane = new ImagePlane(this.scene, topTex, bgrTexture, positions[i]);
            // console.log(imagePlane);
            imagePlane.setup();
            imagePlane.createText(textArr[i]);
            this.imagePlanes.push(imagePlane);
        }
    };

    update()
    {
        for(const plane of this.imagePlanes)
        {
            plane.update();
        }
    };

    onMouseDown(e)
    {
        for(const plane of this.imagePlanes)
        {
            plane.onMouseDown(e);
        }
    };

    onMouseUp(e)
    {
        for(const plane of this.imagePlanes)
        {
            plane.onMouseUp(e);
        }
    };

    onMouseMove(e)
    {
        for(const plane of this.imagePlanes)
        {
            plane.onMouseMove(e);
        }
    };
}